"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const Hoverable = ({ children, style }) => {
    const [isHovering, setIsHovering] = React.useState(false);
    const hoverStyle = Object.assign({}, style, { background: isHovering ? colors_1.beige : colors_1.white });
    return (React.createElement("div", { onMouseOver: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false), style: hoverStyle }, children));
};
class SelectableList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { children, device } = this.props;
        const filteredChildren = React.Children.toArray(children).filter(React.isValidElement);
        const childCount = filteredChildren.length;
        return (React.createElement("div", { style: {
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
            } }, filteredChildren.map((child, index) => {
            return (React.createElement(Hoverable, { key: index, style: {
                    padding: device !== 'Mobile' ? '0 16px' : '0 24px',
                    minHeight: device !== 'Mobile' ? 56 : 72,
                } },
                child,
                index !== childCount - 1 && React.createElement("div", { style: { height: 1, background: colors_1.titanium } })));
        })));
    }
}
exports.default = SelectableList;
